import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('customer/index', {params});
    },
    getCustomer(params) {
        return Service().get('customer/get-customer', {params});
    },
    show(id) {
        return Service().get('customer/show/'+id);
    },
    create(params) {
        return Service().post('customer/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('customer/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('customer/delete/'+id);
    },
}